module.exports = __webpack_public_path__ + "ossetia.svg?4017ffaa4be6e9881f7d0ba8ac02e9be";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/ossetia.svg
// module id = 258
// module chunks = 10